import axiosClient from "../axios/axiosClient";

export function getPartners() {
  return axiosClient.get("/partners");
}

export function getPartner(partnerId) {
  return axiosClient.get(`/partners/${partnerId}`);
}

export function createPartner(data) {
  return axiosClient.post("/partners", data);
}

export const updatePartner = (partnerId, data) => {
  return axiosClient.put(`/partners/${partnerId}`, data);
};

export function deletePartner(partnerId) {
  return axiosClient.delete(`/partners/${partnerId}`);
}
